module.exports = __webpack_public_path__ + "img/kaitongvip.a9fa896f.png";